export default "__VITE_ASSET__5b0882ec__"